import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ticket-state" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_3 = { class: "timeline-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-dot" }, null, -1)
const _hoisted_5 = { class: "timeline-text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_7 = { class: "timeline-content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-dot" }, null, -1)
const _hoisted_9 = { class: "timeline-text" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_11 = { class: "timeline-content" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-dot" }, null, -1)
const _hoisted_13 = { class: "timeline-text" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_15 = { class: "timeline-content" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-dot" }, null, -1)
const _hoisted_17 = { class: "timeline-text" }
const _hoisted_18 = {
  key: 4,
  class: "timeline-row active"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_20 = { class: "timeline-content" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-dot" }, null, -1)
const _hoisted_22 = { class: "timeline-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomCard = _resolveComponent("CustomCard")!

  return (_openBlock(), _createBlock(_component_CustomCard, { optClass: "t-state" }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("COMMON.STATUS")), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.ticketStateisClosedOrCancelled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["timeline-row", {
            active: _ctx.getTrimmedStateStatus(0) === 'actual',
            past: _ctx.getTrimmedStateStatus(0) === 'completed'
          }])
            }, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t(`COMMON.RMA_STATES_LONG.${_ctx.getTrimmedStateLabel(0)}`)), 1)
              ])
            ], 2))
          : _createCommentVNode("", true),
        (!_ctx.ticketStateisClosedOrCancelled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["timeline-row", {
            active: _ctx.getTrimmedStateStatus(1) === 'actual',
            past: _ctx.getTrimmedStateStatus(1) === 'completed'
          }])
            }, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t(`COMMON.RMA_STATES_LONG.${_ctx.getTrimmedStateLabel(1)}`)), 1)
              ])
            ], 2))
          : _createCommentVNode("", true),
        (!_ctx.ticketStateisClosedOrCancelled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["timeline-row", {
            active: _ctx.getTrimmedStateStatus(2) === 'actual',
            past: _ctx.getTrimmedStateStatus(2) === 'completed'
          }])
            }, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.t(`COMMON.RMA_STATES_LONG.${_ctx.getTrimmedStateLabel(2)}`)), 1)
              ])
            ], 2))
          : _createCommentVNode("", true),
        (!_ctx.ticketStateisClosedOrCancelled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(["timeline-row", {
            active:
              (_ctx.getTrimmedStateStatus(3) === 'actual' ||
                _ctx.getTrimmedStateStatus(3) === 'completed') &&
              _ctx.editedStateTimeline.length <= 4,
            past: _ctx.editedStateTimeline.length > 4
          }])
            }, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t(`COMMON.RMA_STATES_LONG.${_ctx.getTrimmedStateLabel(3)}`)), 1)
              ])
            ], 2))
          : _createCommentVNode("", true),
        (
            _ctx.getTrimmedStateLabel(4) === 'CANCELLED' ||
              _ctx.getTrimmedStateLabel(4) === 'CLOSED'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.t(`COMMON.RMA_STATES_LONG.${_ctx.getTrimmedStateLabel(4)}`)), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}